import { Button, Divider, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import CancelIcon from '@mui/icons-material/Cancel';
import { customerPageStyling } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { SelectCar } from './selectCars/selectCar';
import { SelectService } from './selectService';
import { MessagePopUp } from '../popUpMessage';
import { useCustomerBookingCart } from '../selectedCustomerData';
import { SelectAddress } from './selectAddress';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { enqueueSnackbar } from 'notistack';

export const AddBooking = () => {
  const {
    selectedCustomerData,
    setExpandedCards,
    expandedCards,
    cartCardsData,
    setUpdateData,
    setCartCards,
    addressList,
    updateData,
    setCartId,
    CartId,
    carList,
    refreshCartData,
  } = useCustomerBookingCart();

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [cityId, setCityId] = useState(0);

  useEffect(() => {
    if (cartCardsData.length === 0 || cartCardsData[0].services.length === 0) {
      handleFirstCard();
    } else if (cityId !== selectedCustomerData?.city.id) {
      const updatedCartCards = cartCardsData.map((card) => {
        if (card.selectedAddress) {
          return {
            ...card,
            cityId: selectedCustomerData.city.id,
            areaId: 0,
            address: !Array.isArray(card.address)
              ? card.address
              : addressList?.addresses?.filter((x) => x.cityID === selectedCustomerData.city.id) || [],
          };
        } else {
          return card;
        }
      });
      setCartCards(updatedCartCards);
      setCityId(selectedCustomerData.city.id);
    } else if (updateData) {
      const updatedCartCards = cartCardsData.map((card) => {
        if (card.selectedAddress) {
          return {
            ...card,
            cityId: selectedCustomerData.city.id,
            address: !Array.isArray(card.address)
              ? card.address
              : addressList?.addresses?.filter((x) => x.cityID === selectedCustomerData.city.id) || [],
          };
        } else if (card.selectedCar) {
          return {
            ...card,
            car: carList
          };
        } else {
          return card;
        }
      });
      setCartCards(updatedCartCards);
    }
    setUpdateData(false);
  }, [selectedCustomerData?.city.id, selectedCustomerData?.area.id, updateData]);

  const handleFirstCard = () => {
   const availableCars = Array.isArray(carList)
  ? carList.filter(
      car => !cartCardsData?.some(card =>
        !card.selectedCar && card.car?.customerCarId === car.customerCarId
      )
    )
  : [];

    setCartCards([
      {
        id: `card1`,
        cityId: selectedCustomerData?.city.id,
        areaId: selectedCustomerData?.area.id,
        car: availableCars.length > 0 ? availableCars : (carList || []),
    address:
      addressList?.addresses?.filter(
        (x) => x.cityID === selectedCustomerData?.city?.id
      ) || [],
        services: [],
        totalDiscount: 0,
        totalTax: 0,
        totalAmount: 0,
        selectedCar: false,
        selectedAddress: false
      }
    ]);

    setExpandedCards([false]);
    setCityId(selectedCustomerData.city.id);
  };

  const handleAddCard = () => {
    const check = cartCardsData[cartCardsData.length - 1]?.services.length;
    if (check > 0 || cartCardsData.length === 0) {
      const selectedCarIds = cartCardsData
        .filter((card) => !card.selectedCar)
        .map((card) => card.car.customerCarId);

      const filteredCarList = carList.filter(
        (car) => !selectedCarIds.includes(car.customerCarId)
      );
      if (selectedCarIds.length > 0) {
        {
          setCartCards((prevData) => [
            ...prevData,
            {
              id: `card${cartCardsData.length + 1}`,
              cityId: selectedCustomerData?.city.id,
              areaId: selectedCustomerData?.area.id,
              car: filteredCarList,
              address:
                addressList?.addresses?.filter(
                  (x) => x.cityID === selectedCustomerData.city.id
                ) || {},
              services: [],
              totalTax: 0,
              totalDiscount: 0,
              totalAmount: 0,
              selectedCar: true,
              selectedAddress: true
            }
          ]);
        }
      } else {
        setCartCards((prevData) => [
          ...prevData,
          {
            id: `card${cartCardsData.length + 1}`,
            cityId: selectedCustomerData?.city.id,
            areaId: selectedCustomerData?.area.id,
            car: carList,
            address:
              addressList?.addresses?.filter(
                (x) => x.cityID === selectedCustomerData.city.id
              ) || {},
            services: [],
            totalTax: 0,
            totalDiscount: 0,
            totalAmount: 0,
            selectedCar: true,
            selectedAddress: true
          }
        ]);
      }

      setExpandedCards((prevExpanded) => [
        ...prevExpanded.map(() => true),
        prevExpanded[expandedCards.length - 1]
      ]);
    } else {
      const message = !cartCardsData[cartCardsData.length - 1].selectedCar
        ? `for selected car No. ${cartCardsData[cartCardsData.length - 1].car.registrationNumber} `
        : '';
      enqueueSnackbar(
        ` Use the previus card to book the service ${message}, its empty. `,
        {
          variant: 'error'
        }
      );
    }
  };

  const handleToggleExpand = (index) => {
    setExpandedCards((prevExpanded) => {
      const newExpanded = [...prevExpanded];
      newExpanded[index] = !newExpanded[index];
      return newExpanded;
    });
  };

  const handelChangeCar = (cardId, select, index) => {
    const selectedCarIds = cartCardsData
      .filter((card) => card.id !== cardId && !card.selectedCar)
      .map((card) => card.car.customerCarId);

    const filteredCarList = carList.filter(
      (car) => !selectedCarIds.includes(car.customerCarId)
    );

    const resetCarList = filteredCarList.length > 0 ? filteredCarList : carList;

    const updatedCards = cartCardsData.map((card, idx) => {
      if (card.id === cardId) {
        return {
          ...card,
          car: resetCarList,
          address: card.address,
          services: [],
          totalAmount: 0,
          totalTax: 0,
          totalDiscount: 0,
          selectedCar: select,
          selectedAddress: card.selectedAddress,
        };
      }
      return card;
    });

    setCartCards(updatedCards);

    setExpandedCards((prev) => {
      const updated = [...prev];
      updated[index] = false;
      return updated;
    });
  };

  const handelChangeAddress = (cardId, select) => {
    const selectedCarIds = cartCardsData
      .filter((card) => card.id !== cardId && !card.selectedCar)
      .map((card) => card.car.customerCarId);

    const filteredCarList = carList.filter(
      (car) => !selectedCarIds.includes(car.customerCarId)
    );

    const resetCarList = filteredCarList.length > 0 ? filteredCarList : carList;

    const updatedCards = cartCardsData.map((card, idx) => {
      if (card.id === cardId) {
        return {
          ...card,
          cityId: selectedCustomerData.city.id,
          areaId: selectedCustomerData.area.id,
          car: card.car,
          address:
            addressList?.addresses?.filter(
              (x) => x.cityID === selectedCustomerData.city.id
            ) || [],
          services: [],
          totalAmount: 0,
          totalTax: 0,
          totalDiscount: 0,
          selectedCar: card.selectedCar,
          selectedAddress: select
        };
      }
      return card;
    });

    setCartCards(updatedCards);
  };

  const handleDeleteCard = (index) => {
    if (cartCardsData[index].selectedCar) {
      setCartCards((prevCards) => {
        const newCards = [...prevCards];
        newCards.splice(index, 1);
        return newCards;
      });
      setExpandedCards((prevExpanded) => {
        const newExpanded = [...prevExpanded];
        newExpanded.splice(index, 1);
        return newExpanded;
      });
      if (cartCardsData.length === 1) {
        handleFirstCard();
      }
    } else {
      setDeleteConfirmationOpen(true);
      setSelectedDeleteIndex(index);
    }
  };

  const deleteCard = () => {
    if (selectedDeleteIndex === null) return;

    setCartCards((prevCards) => {
      const newCards = [...prevCards];
      newCards.splice(selectedDeleteIndex, 1);
      return newCards;
    });

    setExpandedCards((prevExpanded) => {
      const newExpanded = [...prevExpanded];
      newExpanded.splice(selectedDeleteIndex, 1);
      return newExpanded;
    });

    setSelectedDeleteIndex(null);
  };

  const handleDeleteConfirmation = () => {
    setDeleteConfirmationOpen(false);
    const card = cartCardsData[selectedDeleteIndex]
    if (
      selectedDeleteIndex !== null &&
      card.services.length === 0
    ) {
      setCartCards((prevCards) => {
        const newCards = [...prevCards];
        newCards.splice(selectedDeleteIndex, 1);
        return newCards;
      });

      setExpandedCards((prevExpanded) => {
        const newExpanded = [...prevExpanded];
        newExpanded.splice(selectedDeleteIndex, 1);
        return newExpanded;
      });

      setSelectedDeleteIndex(null);
    } else if (
      selectedDeleteIndex !== null &&
      card.services.length > 0
    ) {
      if (cartCardsData.length === 1) {
        CustomerCartServicess.deleteData(CartId)
          .then(() => {
            deleteCard();
            setCartId(0);
          })
          .catch((error) => {
            enqueueSnackbar(` Error in removing card `, {
              variant: 'error'
            });
            return;
          });
      } else {
        for (
          let i = 0;
          i < cartCardsData[selectedDeleteIndex].services.length;
          i++
        ) {
          const cartServiceId =
            cartCardsData[selectedDeleteIndex].services[i].cartServiceId;

          CustomerCartServicess.removeServiceFromCart(cartServiceId)
            .then(() => {
              deleteCard();
            })
            .catch((error) => {
              enqueueSnackbar(` Error in removing card ${cartServiceId}`, {
                variant: 'error'
              });
              return;
            });
        }
      }
    }
    if (cartCardsData.length === 1) {
      setCartCards((prevData) => [
        ...prevData,
        {
          id: `card1`,
          cityId: selectedCustomerData?.city.id,
          areaId: selectedCustomerData?.area.id,
          car: carList,
          address:
            addressList?.addresses?.filter(
              (x) => x.cityID === selectedCustomerData.city.id
            ) || [],
          services: [],
          totalDiscount: 0,
          totalTax: 0,
          totalAmount: 0,
          selectedCar: true,
          selectedAddress: true
        }
      ]);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
    setSelectedDeleteIndex(null);
  };

  return (
    <>
      <div style={customerPageStyling.addBooking(false).cartContainer}>
        <Typography variant="h3">Cart</Typography>
        <IconButton onClick={handleAddCard}>+</IconButton>
      </div>
      {cartCardsData?.map((card, index) => (
        <div
          key={card.id - index}
          style={
            customerPageStyling.addBooking(expandedCards[index]).cardContainer
          }
        >
          {expandedCards[index] && (
            <Typography
              variant="h4"
              style={{ position: 'absolute', padding: '20px' }}
            >
              {card?.car?.length > 1
                ? 'Select Car'
                : card?.car?.length === 0
                  ? 'Add Car'
                  : `Car: ${card.car.registrationNumber}`}
            </Typography>
          )}
          <div
            style={
              customerPageStyling.addBooking(expandedCards[index], index).card
            }
          >
            {!expandedCards[index] && (
              <>
                <SelectCar
                  data={card}
                  index={index}
                  Cards={cartCardsData}
                  handelChangeCar={handelChangeCar}
                  page="Booking"
                />

                <SelectAddress
                  data={card}
                  index={index}
                  Cards={cartCardsData}
                  handelChangeAddress={handelChangeAddress}
                  page="Booking"
                />
                <SelectService index={index} />
              </>
            )}
          </div>
          <div
            style={
              customerPageStyling.addBooking(expandedCards[index], index)
                .cardBtn.cardTotal
            }
          >
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
              Total Amount :{cartCardsData[index].totalAmount.toFixed(2) || '0'}
              {index}
            </span>
          </div>
          <IconButton
            style={
              customerPageStyling.addBooking(expandedCards[index], index)
                .cardBtn.openBtn
            }
            onClick={() => handleToggleExpand(index)}
          >
            <ExpandCircleDownIcon />
          </IconButton>
          <IconButton
            style={
              customerPageStyling.addBooking(expandedCards[index]).cardBtn
                .cancelBtn
            }
            onClick={() => handleDeleteCard(index)}
          >
            <CancelIcon />
          </IconButton>
          <MessagePopUp
            openPopUp={deleteConfirmationOpen}
            cancel={handleDeleteCancel}
            conformation={handleDeleteConfirmation}
            message="Are you sure you want to delete this item from your cart? This action cannot be undone."
          />
        </div>
      ))}
    </>
  );
};